/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, March 28th 2022, 11:30:27 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

/** Add New*/
import { PrimaryKeyValue } from "lib/types";
import { OSActionButton, useToggleState } from "ui-widgets";
import { useOSAPIFormContext } from "ui-widgets/forms/providers";
import { UseControllerReturn } from "react-hook-form";

/** Add New*/

interface AddItemFormRenderPropSpec<RelatedObject> {
  newFormOpenState: boolean;
  closeNewFormFn: () => void;
  updatePrimaryObject: (updatedForeignKeyId: PrimaryKeyValue<RelatedObject>, autoSavePrimaryForm?: boolean) => void;
}

export interface APIMany2OneSelectAddNewProps<RelatedObject> {
  renderRelatedObjectForm: (spec: AddItemFormRenderPropSpec<RelatedObject>) => JSX.Element;
  onChange: UseControllerReturn["field"]["onChange"];
}

export const APIMany2OneSelectAddNewButton = <PrimaryObject, RelatedObject>({
  renderRelatedObjectForm,
  onChange,
}: APIMany2OneSelectAddNewProps<RelatedObject>) => {
  const { submitAPIForm } = useOSAPIFormContext<PrimaryObject>();

  const { open: newFormOpenState, handleOpen: openNewFormFn, handleClose: closeNewFormFn } = useToggleState();

  const updatePrimaryObject = (
    updatedForeignKeyId: PrimaryKeyValue<RelatedObject>,
    autoSavePrimaryForm: boolean = true
  ) => {
    onChange(updatedForeignKeyId);
    if (autoSavePrimaryForm) submitAPIForm(); // AutoSave the Main form when this related record is saved or edited
    closeNewFormFn();
  };

  return (
    <>
      <OSActionButton actionStyle="add" buttonType="floating" onClick={openNewFormFn} />
      {renderRelatedObjectForm({ updatePrimaryObject, closeNewFormFn, newFormOpenState })}
    </>
  );
};
